// 引入工具函数
import req from '@/utils/request';

// 获取处方可打印的处方列表
export const queryRecipeBatchPrint = (params) => {
    return req.post('/order/payment/queryRecipeBatchPrint', params);
}
//查询是否存在打印任务
export const queryQueue = (params) => {
    return req.get('/task/queryQueue', params);
}
